import { List } from "immutable";
import * as Moment from "moment";
import * as React from "react";
import { RichText } from "../../components/components";
import { noResultsText } from "../../custom_api/api";
import { ActivityEditionN } from "../../custom_models/activity_edition";
import { moment } from "../../custom_utils/moment";
import { maybeTimeSpan } from "./activity_edition";
import { Book } from "./books_block";
import { trackActivitySubscribe } from "./library/tracking";

export interface ActivityEditionListProps {
  readonly editions: List<ActivityEditionN>
}

export interface ActivityEditionListState { }

const activityEditionListStateZero: ActivityEditionListState = {}

const sortEditionsByDateAscending: (
  x: ActivityEditionN,
  y: ActivityEditionN
) => number = (x, y) => (x.activityEvents.first().date < y.activityEvents.first().date ? -1 : 1);

const ActivityEditionElement: (edition: ActivityEditionN) => JSX.Element = e => {
  let retRichText = RichText(false, "view", () => e.signupText, () => null)
  return (
    <li className="edition">
      <div className="edition__column edition__column--first">
        <div className="edition__info">
          {e.signupText && (
            <div className="rich__text">{<retRichText.type key={`rich-text-key-${e.id}`} {...retRichText.props} />}</div>
          )}

          {e.book && (
            <aside className="edition__book">
              <Book
                title={e.book.title}
                author={e.book.author}
                imageUrl={`/api/v1/Book/${e.book.id}/ImageDownload`}
                imageAlt={`Boekentip ${e.book.title} - ${e.book.author}`}
                className="book--edition-list"
                url={e.book.url}
                heading="h4"
              />
            </aside>
          )}
        </div>
      </div>

      <div className="edition__column edition__column--second">
        {e.activityEvents.sort((a, b) => a.date < b.date ? -1 : 1).map((event, k) => {
          const date = moment(event.date).format("dddd D MMMM YYYY")
          return (
            <div className="edition__event" key={`edition-event-${date}`}>
              <span className="sr-text">Waar en wanneer: </span>
              <time dateTime={moment(event.date).format('YYYY-MM-DD')}>
                {date.charAt(0).toUpperCase() + date.slice(1)} {maybeTimeSpan(event)}
                <svg className="edition__icon" width="15" height="17" aria-hidden="true"><use xlinkHref="#icon--calendar" /></svg>
              </time>
              <address>
                {event.location}
                <svg className="edition__icon" width="15" height="18" aria-hidden="true"><use xlinkHref="#icon--location" /></svg>
              </address>
              {e.cost && <div>
                {e.cost}
                <svg className="edition__icon" width="16" height="16" aria-hidden="true"><use xlinkHref="#icon--price" /></svg>
              </div>}
            </div>
          )
        })}

        {e.signupUrl &&
          <div className="edition__signup">
            <a
              href={e.signupUrl}
              target="_blank"
              className="link button"
              onClick={() =>
                e.activityEvents.map(event => (
                  trackActivitySubscribe(
                    Moment(event.date).format("DD/MM/YYYY"),
                    event.start,
                    event.end
                  )
                ))
              }
            >
              Meld je aan
            </a>
          </div>
        }
      </div>
    </li>
  );
}

export class ActivityEditionList extends React.Component<ActivityEditionListProps, ActivityEditionListState> {
  constructor(props: ActivityEditionListProps) {
    super(props)

    this.state = activityEditionListStateZero
  }

  render() {
    const p = this.props

    const editions: JSX.Element = (
      <section className="edition-list">
        <h3 className="sr-text">Aantal edities gevonden voor deze activiteit: {p.editions.size}</h3>
        <ul className="editions">
          {p.editions.isEmpty()
            ? <li><div>{noResultsText}</div></li>
            : p.editions
              .sort(sortEditionsByDateAscending)
              .map((x, i) => (<ActivityEditionElement {...x} key={`edition-${i}`} />))
              .toArray()}
        </ul>
      </section>
    )

    return <>{editions}</>
  }
}
